export const ID_NATURAL_PERSON = 1;